import React from 'react'
import { FaLaptopCode } from 'react-icons/fa'
import Footer from '../components/Footer'
import Header from '../components/Header'
import projectsdata from './projectsdata'


function Projects() {
    return (
        <div>
            <Header />
            <div className="container projects-intro" >
                <div className="row flex-with-center mt-5">
                    <div className="col-md-6 n-box2 px-3 py-5" data-aos= "fade-down">
                        <div >
                            <h1 className="font-bold ">Projects</h1>
                            <p className="font-bold">Good ideas are not adopted automatically.They must be drive into practice with courageous efforts</p>
                            <button className="primary-button"><a href = "#project">Get Started</a></button>
                        </div>
                    </div>
                    <div className="col-md-6 position-relative">
                        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#0F62FE" d="M43,-68.7C55.6,-58.7,65.8,-46.7,71.3,-33C76.9,-19.4,77.7,-4,75.9,11.2C74.1,26.3,69.6,41.4,60.4,52.8C51.2,64.3,37.4,72.2,22.1,77.7C6.9,83.3,-9.7,86.5,-25.7,83.6C-41.8,80.8,-57.2,71.9,-65.8,58.8C-74.4,45.7,-76.1,28.4,-77,12C-77.9,-4.5,-78.1,-20.1,-73.8,-35.4C-69.5,-50.8,-60.7,-65.8,-47.7,-75.7C-34.6,-85.5,-17.3,-90.3,-1.1,-88.6C15.1,-86.9,30.3,-78.8,43,-68.7Z" transform="translate(100 100)" />
                        </svg>
                        <FaLaptopCode color="white" size="200" className="position-absolute top-50 start-50 translate-middle" />
                    </div>
                </div>
            </div>
            <div className='container projects-list' id = "project" >
                <h3 className='font-bold'>Take a Look of My Projects</h3>
                <hr />
                <div className='row'>
                    {projectsdata.map(project => {
                        return <div className='col-md-4'>
                            <div className='position-relative project'>
                                <img className="project-img" src={project.image} alt="" />
                                <div className='project-content'>
                                    <h3>{project.title}</h3>
                                    <hr/>
                                    <p>{project.description}</p>
                                    <button className='primary-button'>DEMO</button>
                                </div>

                            </div>
                        </div>
                    })}
                </div>
            </div>
            <Footer/>
        </div>

    )
};

export default Projects;
